export default function Linkedin({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M7.18991 8.77103H3.57638C3.41601 8.77103 3.28606 8.90103 3.28606 9.06135V20.6701C3.28606 20.8304 3.41601 20.9604 3.57638 20.9604H7.18991C7.35028 20.9604 7.48023 20.8304 7.48023 20.6701V9.06135C7.48023 8.90103 7.35028 8.77103 7.18991 8.77103Z"
        fill="currentColor"
      />
      <path
        d="M5.38448 3C4.06966 3 3 4.0685 3 5.38186C3 6.69581 4.06966 7.76472 5.38448 7.76472C6.69824 7.76472 7.76704 6.69575 7.76704 5.38186C7.7671 4.0685 6.69824 3 5.38448 3Z"
        fill="currentColor"
      />
      <path
        d="M16.3812 8.4825C14.9299 8.4825 13.857 9.10641 13.2063 9.81532V9.06135C13.2063 8.90103 13.0763 8.77103 12.916 8.77103H9.45538C9.29501 8.77103 9.16506 8.90103 9.16506 9.06135V20.6701C9.16506 20.8304 9.29501 20.9604 9.45538 20.9604H13.061C13.2214 20.9604 13.3513 20.8304 13.3513 20.6701V14.9264C13.3513 12.991 13.8771 12.237 15.2262 12.237C16.6956 12.237 16.8124 13.4457 16.8124 15.026V20.6701C16.8124 20.8305 16.9423 20.9604 17.1027 20.9604H20.7097C20.8701 20.9604 21 20.8305 21 20.6701V14.3025C21 11.4246 20.4512 8.4825 16.3812 8.4825Z"
        fill="currentColor"
      />
    </svg>
  )
}
